namespace $.$$ {

	export class $shm_hitalama_dragtree_drag extends $.$shm_hitalama_dragtree_drag {

		_hold_event?: PointerEvent
		_hold_timer?: ReturnType< typeof setTimeout >
		_hold_pointer = 0
		_hold_start_x = 0
		_hold_start_y = 0
		_active_touch_pointer = 0

		_hold_move_listener = ( event: PointerEvent )=> this.hold_move( event )
		_hold_end_listener = ( event: PointerEvent )=> this.hold_end( event )
		_active_pointer_move_listener = ( event: PointerEvent )=> this.active_pointer_move( event )
		_active_touch_move_listener = ( event: TouchEvent )=> this.active_touch_move( event )
		_active_contextmenu_listener = ( event: Event )=> this.active_contextmenu( event )

		pointerdown( event: PointerEvent ) {
			if( event.pointerType === 'mouse' || this.hold_delay() <= 0 ) {
				super.pointerdown( event )
				return
			}
			if( !this.use_buttons().includes( event.button ) ) return

			this.hold_release()
			this._hold_event = event
			this._hold_pointer = event.pointerId
			this._hold_start_x = event.clientX
			this._hold_start_y = event.clientY

			const document = this.$.$mol_dom_context.document
			document.addEventListener( 'pointermove', this._hold_move_listener, true )
			document.addEventListener( 'pointerup', this._hold_end_listener, true )
			document.addEventListener( 'pointercancel', this._hold_end_listener, true )
			this._hold_timer = this.$.$mol_dom_context.setTimeout(
				()=> this.hold_activate(),
				this.hold_delay(),
			)
		}

		hold_move( event: PointerEvent ) {
			if( event.pointerId !== this._hold_pointer ) return
			const dx = event.clientX - this._hold_start_x
			const dy = event.clientY - this._hold_start_y
			if( dx * dx + dy * dy <= this.hold_move_threshold() ** 2 ) return
			this.hold_release()
		}

		hold_end( event: PointerEvent ) {
			if( event.pointerId !== this._hold_pointer ) return
			this.hold_release()
		}

		hold_activate() {
			const event = this._hold_event
			if( !event ) return
			const pointer = event.pointerId
			this.hold_release()
			this._active_touch_pointer = pointer

			const document = this.$.$mol_dom_context.document
			document.addEventListener( 'pointermove', this._active_pointer_move_listener, { capture: true, passive: false } )
			document.addEventListener( 'touchmove', this._active_touch_move_listener, { capture: true, passive: false } )
			document.addEventListener( 'contextmenu', this._active_contextmenu_listener, true )
			super.pointerdown( event )
		}

		active_pointer_move( event: PointerEvent ) {
			if( event.pointerId !== this._active_touch_pointer ) return
			if( event.cancelable ) event.preventDefault()
		}

		active_touch_move( event: TouchEvent ) {
			if( !this._active_touch_pointer ) return
			if( event.cancelable ) event.preventDefault()
		}

		active_contextmenu( event: Event ) {
			if( !this._active_touch_pointer ) return
			event.preventDefault()
		}

		hold_release() {
			if( this._hold_timer !== undefined ) {
				this.$.$mol_dom_context.clearTimeout( this._hold_timer )
				this._hold_timer = undefined
			}
			const document = this.$.$mol_dom_context.document
			document.removeEventListener( 'pointermove', this._hold_move_listener, true )
			document.removeEventListener( 'pointerup', this._hold_end_listener, true )
			document.removeEventListener( 'pointercancel', this._hold_end_listener, true )
			this._hold_event = undefined
			this._hold_pointer = 0
		}

		active_touch_release() {
			const document = this.$.$mol_dom_context.document
			document.removeEventListener( 'pointermove', this._active_pointer_move_listener, true )
			document.removeEventListener( 'touchmove', this._active_touch_move_listener, true )
			document.removeEventListener( 'contextmenu', this._active_contextmenu_listener, true )
			this._active_touch_pointer = 0
		}

		drag_end( event: PointerEvent ) {
			super.drag_end( event )
			this.active_touch_release()
		}

		destructor() {
			this.hold_release()
			this.active_touch_release()
			super.destructor()
		}

	}

}
